import { render } from "./WebcamControls.vue?vue&type=template&id=5cf12f3c&scoped=true"
import script from "./WebcamControls.vue?vue&type=script&lang=js"
export * from "./WebcamControls.vue?vue&type=script&lang=js"

import "./WebcamControls.vue?vue&type=style&index=0&id=5cf12f3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf12f3c"]])

export default __exports__